import React, { useEffect, useMemo, useState } from "react";
import Menu from "../../../components/layout/menu/index";
import { getSeasonsAll } from "../../../client/seasons";
import { getSeasonMatrix, bulkUpdateSdsStatus, downloadSupplierFiles, deleteSuppliersPerSeason, getSeasonMatrixWithFilters} from "../../../client/seasonDocumentSuppliers";
import { saveAs } from "file-saver";
import ModalSuccess from "../../../components/shared/modals/modalSuccess";
import SelectField from "../../../components/forms/selectOption";
import ModalAlertWarning from "../../../components/shared/modals/modalAlertWarning";
import ModalDelete from "../../../components/shared/modals/modalDelete";
import FilterInput from "../../../components/filters/filterInput";
import ResetFilters from "../../../components/filters/resetFilters";
import RequirementsAdminFilters from "../../../components/filters/requirementsAdminFilters";
import ContentLoader from 'react-content-loader';

function FileIcon(color) {
  return (
    <svg width="14" height="17" viewBox="0 0 14 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M2.99956 16.9545H10.9999C12.5595 16.9545 13.3354 16.1635 13.3354 14.5965V7.7562H7.8811C6.91681 7.7562 6.46488 7.29656 6.46488 6.33227V0.802734H2.99956C1.44771 0.802734 0.664062 1.60116 0.664062 3.16845V14.5965C0.664062 16.1709 1.44771 16.9545 2.99956 16.9545ZM7.90392 6.72409H13.2525C13.1998 6.4152 12.9812 6.1137 12.6273 5.7447L8.46867 1.51856C8.12217 1.15695 7.80588 0.938377 7.48928 0.885342V6.31748C7.48928 6.58845 7.63263 6.72409 7.90392 6.72409Z"
        fill={color.color} />
    </svg>
  );
}
const TableContentLoader = () => {
  return (
    <div className="w-full overflow-hidden overflow-x-auto">
      <ContentLoader 
        speed={2}
        width="100%"
        height={300}
        viewBox="0 0 100% 300"
        preserveAspectRatio="none"
        backgroundColor="#f3f3f3"
        foregroundColor="#ecebeb"
      >

        <rect x="1%" y="20" rx="4" ry="4" width="6%" height="30" />
        
        <rect x="8%" y="20" rx="4" ry="4" width="21%" height="30" />
        

        <rect x="30%" y="20" rx="4" ry="4" width="13%" height="30" />
        
        <rect x="44%" y="20" rx="4" ry="4" width="13%" height="30" />
        
        <rect x="58%" y="20" rx="4" ry="4" width="13%" height="30" />
        
        <rect x="72%" y="20" rx="4" ry="4" width="13%" height="30" />
        
        <rect x="86%" y="20" rx="4" ry="4" width="13%" height="30" />
        
        {[1, 2, 3, 4].map((row, rowIndex) => (
          <React.Fragment key={row}>
            <rect x="1%" y={70 + (rowIndex * 60)} rx="4" ry="4" width="5%" height="20" />
            <rect x="8%" y={70 + (rowIndex * 60)} rx="4" ry="4" width="20%" height="20" />
            <rect x="30%" y={70 + (rowIndex * 60)} rx="4" ry="4" width="12%" height="40" />
            <rect x="44%" y={70 + (rowIndex * 60)} rx="4" ry="4" width="12%" height="40" />
            <rect x="58%" y={70 + (rowIndex * 60)} rx="4" ry="4" width="12%" height="40" />
            <rect x="72%" y={70 + (rowIndex * 60)} rx="4" ry="4" width="12%" height="40" />
            <rect x="86%" y={70 + (rowIndex * 60)} rx="4" ry="4" width="12%" height="40" />
          </React.Fragment>
        ))}
      </ContentLoader>
    </div>
  );
};


export default function SeasonStartRequirements() {
  const [isMenuOpen, setIsMenuOpen] = useState(true);
  const [seasons, setSeasons] = useState([]);
  const [seasonId, setSeasonId] = useState(null);

  const [searchTerm, setSearchTerm] = useState("");
  const [filters, setFilters] = useState({
    supplierIds: [],
    documentIds: [],
    search: ""
  });
  const [resetFiltersFlag, setResetFiltersFlag] = useState(false);
  
  const [docs, setDocs] = useState([]);
  const [sups, setSups] = useState([]);
  const [cells, setCells] = useState([]);
  const [loading, setLoading] = useState(true);
  const [downloadingSds, setDownloadingSds] = useState(null);
  const [downloadingSupplier, setDownloadingSupplier] = useState(null); 
  const [error, setError] = useState(null);

  const [selected, setSelected] = useState(new Set());
  
  const [isApproving, setIsApproving] = useState(false);
  const [isRejecting, setIsRejecting] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);

  const [showModalSuccess, setShowModalSuccess] = useState(false);
  const [modalSuccessText, setModalSuccessText] = useState("");

  const [showSupplierCheckboxes, setShowSupplierCheckboxes] = useState(false);

  const [showAlertModal, setShowAlertModal] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  
  const [showModalDelete, setShowModalDelete] = useState(false);

  const [selectedFilterDocuments, setSelectedFilterDocuments] = useState([]);
  const [selectedSuppliersForDelete, setSelectedSuppliersForDelete] = useState(new Set());
  const [selectedFilterSuppliers, setSelectedFilterSuppliers] = useState([]);

  useEffect(() => {
    if (seasonId) {
      setSearchTerm("");
      
      setFilters({
        supplierIds: [],
        documentIds: [],
        search: ""
      });
      
      setSelectedSuppliersForDelete(new Set());
      
      setShowSupplierCheckboxes(false);
      
      setSelectedFilterDocuments([]);
      setSelectedFilterSuppliers([]);
      
      setResetFiltersFlag(prev => !prev);
    }
  }, [seasonId]); 

  const loadMatrix = async () => {
    if (!seasonId) return;
    
    try {
      setLoading(true);
      setError(null);

      setSelected(new Set());
      setSelectedSuppliersForDelete(new Set());
      setShowSupplierCheckboxes(false);
      
      const m = await getSeasonMatrixWithFilters(seasonId, {
        supplierIds: filters.supplierIds,
        documentIds: filters.documentIds,
        search: filters.search
      });
      
      setDocs(m.documents ?? []);
      setSups(m.suppliers ?? []);
      setCells(m.cells ?? []);
      setSelected(new Set());
    } catch (e) {
      setError(e?.message || String(e));
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadMatrix();
  }, [seasonId, filters]);

const handleSearchChange = (value) => {
  setSearchTerm(value);
  
  setFilters(prev => ({
    ...prev,
    search: value
  }));
};

  const handleApplyFilters = (appliedFilters) => {
    setFilters(prev => ({
      ...prev,
      documentIds: appliedFilters.documentIds || [],
      supplierIds: appliedFilters.supplierIds || []
    }));
    
  };

  const resetAllFilters = () => {
    setSearchTerm("");
    setFilters({
      supplierIds: [],
      documentIds: [],
      search: ""
    });
    setResetFiltersFlag(prev => !prev); 
  };
  
  useEffect(() => {
    (async () => {
      try {
        const res = await getSeasonsAll();
        const list = Array.isArray(res?.data?.data) ? res.data.data : [];
        setSeasons(list);
        if (list.length) setSeasonId(list[0].id);
      } catch (e) {
        setError(e?.message || String(e));
      } finally {
      }
    })();
  }, []);

  const hasFilesForSupplier = useMemo(() => {
    const result = new Map();
    
    sups.forEach(sup => {
      const supplierCells = cells.filter(c => c.supplier_id === sup.id);
      
      const hasAnyFiles = supplierCells.some(c => c.files && c.files.length > 0);
      
      result.set(sup.id, hasAnyFiles);
    });
    
    return result;
  }, [sups, cells]);



  const cellByKey = useMemo(() => {
    const map = new Map();
    for (const c of cells) {
      map.set(`${c.document_id}-${c.supplier_id}`, c);
    }
    return map;
  }, [cells]);

  const downloadCell = async (c, docName, supName) => {
    if (!c || !c.files?.length) return;

    setDownloadingSds(c.sds_id);

    try {
      for (let i = 0; i < c.files.length; i++) {
        const f = c.files[i];

        const resp = await fetch(f.url, { credentials: "omit" });
        if (!resp.ok) throw new Error(`HTTP ${resp.status} al descargar ${f.url}`);
        const blob = await resp.blob();

        // ⭐ Usar el fileName del DTO
        let originalFileName = f.fileName || 'archivo';

        // ⭐ Si no tiene extensión, extraerla de la URL SIN el query string
        if (!originalFileName.includes('.')) {
          // Remover el query string de la URL
          const urlWithoutQuery = f.url.split('?')[0];
          const urlParts = urlWithoutQuery.split('/');
          const urlFileName = urlParts[urlParts.length - 1];
          
          const lastDot = urlFileName.lastIndexOf('.');
          if (lastDot !== -1) {
            const extension = urlFileName.substring(lastDot);
            originalFileName += extension;
          }
        }

        console.log('Descargando con nombre:', originalFileName);
        saveAs(blob, originalFileName);
      }
    } catch (e) {
      console.error(e);
      showAlert(`No se pudo descargar: ${e?.message || e}`);
    } finally {
      setDownloadingSds(null);
    }
  };

  const keyFor = (docId, supId) => `${docId}-${supId}`;

  const toggleCellSelect = (docId, supId, enabled) => {
    if (!enabled) return;
    const k = keyFor(docId, supId);
    setSelected(prev => {
      const next = new Set(prev);
      next.has(k) ? next.delete(k) : next.add(k);
      return next;
    });
  };

  const onCellKeyDown = (e, docId, supId, enabled) => {
    if (!enabled) return;
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      toggleCellSelect(docId, supId, true);
    }
  };

  const showAlert = (message) => {
    setAlertMessage(message);
    setShowAlertModal(true);
  };

  const approveSelected = async () => {
    if (selected.size === 0) {
      showAlert("Selecciona al menos una celda para aprobar.");
      return;
    }

    const ids = Array.from(selected)
      .map(k => cellByKey.get(k)?.sds_id)
      .filter(Boolean);

    if (ids.length === 0) {
      showAlert("No hay elementos válidos para aprobar.");
      return;
    }

    try {
      setIsApproving(true);
      await bulkUpdateSdsStatus(ids, 3);
      setCells(prev => prev.map(c => (ids.includes(c.sds_id) ? { ...c, status: 3 } : c)));
      setSelected(new Set());
      setModalSuccessText("¡Los documentos seleccionados fueron aprobados con éxito!");
      setShowModalSuccess(true);
    } catch (e) {
      showAlert(`No se pudo aprobar: ${e?.response?.data?.message || e.message || e}`);
    } finally {
      setIsApproving(false);
    }
  };

  const rejectSelected = async () => {
    if (selected.size === 0) {
      showAlert("Selecciona al menos una celda para rechazar.");
      return;
    }

    const ids = Array.from(selected)
      .map(k => cellByKey.get(k)?.sds_id)
      .filter(Boolean);

    if (ids.length === 0) {
      showAlert("No hay elementos válidos para rechazar.");
      return;
    }

    try {
      setIsRejecting(true);
      await bulkUpdateSdsStatus(ids, 4);
      setCells(prev => prev.map(c => (ids.includes(c.sds_id) ? { ...c, status: 4 } : c)));
      setSelected(new Set());
      setModalSuccessText("¡Los documentos seleccionados fueron rechazados con éxito!");
      setShowModalSuccess(true);
    } catch (e) {
      showAlert(`No se pudo rechazar: ${e?.response?.data?.message || e.message || e}`);
    } finally {
      setIsRejecting(false);
    }
  };

  const handleDownloadSupplierFiles = async (supplierId, supplierName) => {
    if (!seasonId || !supplierId) {
      showAlert("No hay temporada seleccionada");
      return;
    }

    setDownloadingSupplier(supplierId);
    setError(null);

    try {
      const supplierFileIds = [];
      
      const supplierCells = cells.filter(cell => cell.supplier_id === supplierId);
      
      supplierCells.forEach(cell => {
        if (cell.files && cell.files.length > 0) {
          cell.files.forEach(file => {
            if (file.id) {
              supplierFileIds.push(file.id);
            }
          });
        }
      });
      
      if (supplierFileIds.length === 0) {
        setError(`No se encontraron archivos para descargar del proveedor "${supplierName}"`);
        setDownloadingSupplier(null);
        return;
      }
      
      // ⭐ Este método descarga un ZIP del backend, el backend ya maneja los nombres correctos
      await downloadSupplierFiles(seasonId, supplierId, supplierFileIds);
      
    } catch (error) {
      console.error("Error descargando archivos del proveedor:", error);
      
      if (error.response?.status === 404) {
        setError(`No se encontraron archivos para descargar del proveedor "${supplierName}"`);
      } else {
        setError(`Error al descargar archivos de "${supplierName}": ${error.message || "Error desconocido"}`);
      }
    } finally {
      setDownloadingSupplier(null);
    }
  };

  const handleDeleteSuppliers = async () => {
    if (selectedSuppliersForDelete.size === 0) {
      showAlert("Selecciona al menos un proveedor para eliminar.");
      return;
    }

    if (!seasonId) {
      showAlert("Debes seleccionar una temporada primero.");
      return;
    }

    try {
      setIsDeleting(true);
      
      const supplierIds = Array.from(selectedSuppliersForDelete);
      
      await deleteSuppliersPerSeason(seasonId, supplierIds);
      
      const updatedSups = sups.filter(sup => !selectedSuppliersForDelete.has(sup.id));
      setSups(updatedSups);
      
      const updatedCells = cells.filter(cell => !selectedSuppliersForDelete.has(cell.supplier_id));
      setCells(updatedCells);
      
      setSelectedSuppliersForDelete(new Set());
      setShowSupplierCheckboxes(false);
      setShowModalDelete(false);
      
      setModalSuccessText(`¡Los ${selectedSuppliersForDelete.size} proveedor(es) seleccionados fueron eliminados de la temporada con éxito!`);
      setShowModalSuccess(true);
      
    } catch (error) {
      console.error("Error eliminando proveedores:", error);
      
      if (error.response?.status === 404) {
        showAlert("Temporada no encontrada. Por favor, selecciona otra temporada.");
      } else if (error.response?.status === 400) {
        const errorMessage = error.response?.data?.message || "Datos inválidos para la eliminación";
        showAlert(errorMessage);
      } else {
        showAlert(`No se pudieron eliminar los proveedores: ${error.response?.data?.message || error.message || "Error desconocido"}`);
      }
    } finally {
      setIsDeleting(false);
    }
  };

  return (
    <div className="min-h-screen">
      <Menu isMenuOpen={isMenuOpen} toggleMenu={() => setIsMenuOpen(v => !v)} className="transition-all duration-300" />
      <div className={`flex-1 pt-[67px] transition-all duration-300 ${isMenuOpen ? "xl:pl-[20.7%] lg:pl-[23.7%] pl-0" : "pl-0"} bg-[#F7F8F9] w-full z-50 min-h-screen`}>
        <div className="pt-4 pb-16 px-[3%] min-h-screen">
          <div className="flex flex-col gap-3">
            <div className="flex flex-col items-center justify-between gap-3 md:flex-row">
              <h1 className="text-blue font-itcbold md:text-[32px] text-2xl ">
                Requisitos de Inicio de Temporada
              </h1>
              <div>
                <SelectField
                  title="Temporada:"
                  name="temporadas"
                  value={seasonId ?? ""}
                  onChange={(e) => setSeasonId(Number(e.target.value))}
                  options={seasons.map(s => ({
                    value: s.id,
                    label: s.name
                  }))}
                  placeholder="Seleccione una temporada"
                  width="w-56"
                  bgColor="bg-white"
                  border="border-slate-300"
                />
              </div>
            </div>
            <div className="flex flex-col gap-3 py-2">
              <div className="flex flex-col items-center justify-between gap-3 sm:flex-row ">
                <h2 className="font-itcbook text-base md:text-2xl text-[#6B7280] ">
                  Vista de documentación por proveedor
                </h2>
                {docs.length > 0 && sups.length > 0 && (
                  <button
                    onClick={() => {
                      if (showSupplierCheckboxes) {
                        if (selectedSuppliersForDelete.size > 0) {
                          setShowModalDelete(true);
                        } else {
                          setShowSupplierCheckboxes(false);
                        }
                      } else {
                        setShowSupplierCheckboxes(true);
                      }
                    }}
                    className="flex items-center justify-center gap-2 p-2 px-3 transition-all duration-200 ease-in-out rounded-lg bg-red hover:bg-red-700">
                    <p className="text-sm text-white duration-200 transitions-colors font-itcbook">
                      {showSupplierCheckboxes 
                        ? (selectedSuppliersForDelete.size > 0 ? `Eliminar (${selectedSuppliersForDelete.size})` : "Cancelar") 
                        : "Eliminar proveedor(es)"}
                    </p>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="white" xmlns="http://www.w3.org/2000/svg">
                      <path d="M12.7008 3.10083L12.945 4.79167H16.25C16.4158 4.79167 16.5747 4.85751 16.6919 4.97472C16.921 5.25091 16.875 5.41667 16.25 6.04167H15.6092L14.8817 14.5292C14.8375 15.0458 14.8017 15.4708 14.7442 15.8142C14.6858 16.1717 14.5967 16.4917 14.4225 16.7883C14.149 17.2543 13.7424 17.6278 13.255 17.8608C12.945 18.0083 12.6183 18.0692 12.2567 18.0975C11.9092 18.125 11.4833 18.125 10.965 18.125H9.035C8.51667 18.125 8.09083 18.125 7.74333 18.0975C7.38167 18.0692 7.055 18.0083 6.745 17.8608C6.25757 17.6278 5.85098 17.2543 5.5775 16.7883C5.4025 16.4917 5.315 16.1717 5.25583 15.8142C5.19833 15.47 5.1625 15.0458 5.11833 14.5292L4.39083 6.04167H3.75C3.58424 6.04167 3.42527 5.97582 3.30806 5.85861C3.19085 5.7414 3.125 5.58243 3.125 5.41667C3.125 5.25091 3.19085 5.09193 3.30806 4.97472C3.42527 4.85751 3.58424 4.79167 3.75 4.79167H7.055L7.29917 3.10083L7.30833 3.05C7.46 2.39167 8.025 1.875 8.73333 1.875H11.2667C11.975 1.875 12.54 2.39167 12.6917 3.05L12.7008 3.10083ZM8.3175 4.79167H11.6817L11.4683 3.31167C11.4283 3.1725 11.3267 3.125 11.2658 3.125H8.73417C8.67333 3.125 8.57167 3.1725 8.53167 3.31167L8.3175 4.79167ZM9.375 8.75C9.375 8.58424 9.30915 8.42527 9.19194 8.30806C9.07473 8.19085 8.91576 8.125 8.75 8.125C8.58424 8.125 8.42527 8.19085 8.30806 8.30806C8.19085 8.42527 8.125 8.58424 8.125 8.75V12.9167C8.125 13.0824 8.19085 13.2414 8.30806 13.3586C8.42527 13.4758 8.58424 13.5417 8.75 13.5417C8.91576 13.5417 9.07473 13.4758 9.19194 13.3586C9.30915 13.2414 9.375 13.0824 9.375 12.9167V8.75ZM11.875 8.75C11.875 8.58424 11.8092 8.42527 11.6919 8.30806C11.5747 8.19085 11.4158 8.125 11.25 8.125C11.0842 8.125 10.9253 8.19085 10.8081 8.30806C10.6908 8.42527 10.625 8.58424 10.625 8.75V12.9167C10.625 13.0824 10.6908 13.2414 10.8081 13.3586C10.9253 13.4758 11.0842 13.5417 11.25 13.5417C11.4158 13.5417 11.5747 13.4758 11.6919 13.3586C11.8092 13.2414 11.875 13.0824 11.875 12.9167V8.75Z" fill="white"/>
                    </svg>
                  </button>
                )}
              </div>
{(docs.length > 0 || filters.search || filters.supplierIds.length > 0 || filters.documentIds.length > 0) && (              <div className="flex flex-col items-center justify-end w-full gap-2 sm:flex-row">
                <FilterInput
                  placeholder="Buscar documentos"
                  value={searchTerm}
                  onChange={(e) => {
                      const inputValue = e.target.value;
                          handleSearchChange(inputValue)
                      
                  }}                />
                <div className="flex items-center gap-2">
                <RequirementsAdminFilters
                  applyFilters={handleApplyFilters}
                  resetFlag={resetFiltersFlag}
                  seasonId={seasonId}
                  selectedDocuments={selectedFilterDocuments}
                  setSelectedDocuments={setSelectedFilterDocuments}
                  selectedSuppliers={selectedFilterSuppliers}
                  setSelectedSuppliers={setSelectedFilterSuppliers}
                />
                <ResetFilters
                  borderColor="border-blue-light"
                  textColor="text-[#6B7280]"
                  font="font-itcbook"
                  onClick={resetAllFilters}
                />
                </div>

              </div>
              )}
            </div>

            {!loading && docs.length > 0 && (
              <>
              {(isApproving || isRejecting) && (
                <div className="fixed inset-0 z-40 bg-black bg-opacity-50 pointer-events-auto"></div>
              )}
              <div className={`fixed z-10  transform -translate-x-1/2 bottom-4 left-1/2 
                            ${isMenuOpen ? "xl:pl-[20.7%] lg:pl-[23.7%] pl-0" : "pl-0"}`}>
                <div className="flex gap-3">
                  <button
                    type="button"
                    disabled={isApproving || isRejecting || selected.size === 0}
                    onClick={approveSelected}
                      className={`p-3 text-lg flex items-center justify-center h-[50px] text-white rounded-md font-itcmedium
                         ${isApproving ? 'w-auto px-6': 'w-[120px]'} 
                         ${selected.size === 0 ? 'bg-gray cursor-not-allowed' : 'bg-green '}
                         `}
                    title="Aprobar seleccionados"
                    aria-label="Aprobar documentos seleccionados"
                  >
                    {isApproving ? (
                      <div className="flex items-center gap-2">
                        <span>Aprobando</span>
                        <svg className="w-5 h-5 mr-2 animate-spin" viewBox="0 0 24 24" fill="none">
                          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"></path>
                        </svg>
                      </div>
                    ) : (
                      <span>Aprobar</span>
                    )}
                  </button>
                  
                  <button
                    type="button"
                    disabled={isApproving || isRejecting || selected.size === 0}
                    onClick={rejectSelected}
                      className={`p-3 text-lg h-[50px] flex items-center justify-center  rounded-md border-[2px] bg-[#F7F8F9]  font-itcmedium
                        ${isRejecting ? 'w-auto': 'w-[120px]'} 
                         ${selected.size === 0 ? 'border-gray  text-gray cursor-not-allowed' : 'border-red text-red  '}
                        `}
                    title="Rechazar seleccionados"
                    aria-label="Rechazar documentos seleccionados"
                  >
                    {isRejecting ? (
                      <div className="flex items-center gap-2">
                        <span>Rechazando</span>
                        <svg className="w-5 h-5 mr-2 animate-spin" viewBox="0 0 24 24" fill="none">
                          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"></path>
                        </svg>
                      </div>
                    ) : (
                      <span>Rechazar</span>
                    )}
                  </button>
                </div>
              </div>
              </>
            )}

            {error && (
              <div className="p-3 text-sm text-red-700 border border-red-200 rounded-xl bg-red-50">
                Error: {error}
              </div>
            )}
            {loading ? (
              <TableContentLoader rows={4} columns={5} />

            ) : (
            <>
            {docs.length === 0 ? (
              <div className="flex flex-col items-center justify-center mt-4">
                <div className="p-6 text-center">
                  <p className="my-8 text-lg text-red font-itcbook">
                    {filters.search || filters.supplierIds.length > 0 || filters.documentIds.length > 0
                      ? "No se encontraron documentos con los filtros aplicados."
                      : "Aún no se le ha asignado documentos a esta temporada."}
                  </p>
                </div>
              </div>
            ) : (
              <div className="w-full overflow-hidden overflow-x-auto">
              <table className="w-full bg-white border-collapse table-fixed" role="grid" aria-label="Matriz documentos por proveedor">
                <thead>
                  <tr className="">
                    <th className="w-[80px] px-3 py-3 text-sm font-itcbold text-center border text-blue border-slate-300">#</th>
                    <th className="px-4 w-[260px] py-3 text-sm font-itcbold border text-blue border-slate-300">Documento</th>
                    {sups.map((sup) => (
                      <th key={sup.id} className="px-4 py-3 w-[162px] text-sm text-center border font-itcbold text-blue border-slate-300">
                        <div className="flex items-center justify-center gap-2">
                          {showSupplierCheckboxes && (
                            <input
                              type="checkbox"
                              checked={selectedSuppliersForDelete.has(sup.id)}
                              onChange={() => {
                                setSelectedSuppliersForDelete(prev => {
                                  const next = new Set(prev);
                                  if (next.has(sup.id)) {
                                    next.delete(sup.id);
                                  } else {
                                    next.add(sup.id);
                                  }
                                  return next;
                                });
                              }}
                              className="w-4 h-4 rounded border-slate-300 focus:ring-blue-500"
                              aria-label={`Seleccionar proveedor ${sup.name}`}
                            />
                          )}
                          <span>{sup.name}</span>
                        </div>
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody className="text-sm text-slate-800">
                  {docs.map((doc, r) => (
                    <tr key={doc.id}>
                      <td className="px-3 py-3 text-center border font-itcmedium border-slate-300">{r + 1}</td>
                      <td className="px-4 py-3 border font-itcbold border-slate-300">{doc.name}</td>
                      {sups.map((sup) => {
                        const key = keyFor(doc.id, sup.id);
                        const c = cellByKey.get(key);
                        const hasFiles = !!(c?.files?.length);
                        const isBusy = downloadingSds === c?.sds_id;
                        const isSelected = selected.has(key);
                        const status = c?.status;
                        const isAssigned = c && c.sds_id !== 0;
                        const enabled = isAssigned && hasFiles && status == 2;
                        const iconColor = hasFiles ?
                          (status == 3 ? "#76A140" : status == 4 ? "#FF0004" : "#09121F") : ("#09121F");
                        return (
                          <td
                            key={sup.id}
                            className={[
                              "px-4 py-3 border border-slate-300 text-center transition-colors",
                              enabled
                                ? (isSelected ? "bg-blue-100 hover:bg-blue-200 cursor-pointer" : "hover:bg-blue-50 cursor-pointer")
                                : "bg-slate-50 text-slate-400"
                            ].join(" ")}
                            aria-selected={isSelected}
                            tabIndex={enabled ? 0 : -1}
                            onClick={() => toggleCellSelect(doc.id, sup.id, enabled)}
                            onKeyDown={(e) => onCellKeyDown(e, doc.id, sup.id, enabled)}
                          >
                            <button
                              type="button"
                              disabled={!isAssigned || !hasFiles || isBusy}
                              onClick={(e) => {
                                e.stopPropagation();
                                downloadCell(c, doc.name, sup.name);
                              }}
                              className={[
                                "inline-flex h-9 w-9 items-center justify-center rounded-md transition focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500",
                                !c || !hasFiles
                                  ? "bg-slate-100 text-slate-400"
                                  : "bg-[#D9D9D9] text-white",
                              ].join(" ")}
                              title={!isAssigned ? "No asignado" : (hasFiles ? "Descargar archivos" : "Sin archivos")}
                              aria-label={!isAssigned ? "No asignado" : "Descargar archivos"}
                            >
                              {isBusy ? (
                                <svg className="w-5 h-5 animate-spin" viewBox="0 0 24 24" fill="none">
                                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"></path>
                                </svg>
                              ) : (
                                <FileIcon color={iconColor} />
                              )}
                            </button>
                            <div className="mt-1 text-[11px] text-slate-500 select-none">
                              {hasFiles ? `${c.files.length} archivo(s)` : (!isAssigned ? "No asignado" : "Sin archivos")}
                            </div>
                          </td>
                        );
                      })}
                    </tr>
                  ))}


                  {sups.length > 0 && (
                    <tr className="bg-white">
                      <td className="px-3 py-3 text-center border font-itcmedium border-slate-300">{docs.length + 1}</td>
                      <td className="px-4 py-3 border font-itcbold border-slate-300">Descargar documentos</td>
                      {sups.map((sup) => {
                        const hasFiles = hasFilesForSupplier.get(sup.id) || false;
                        const isDownloading = downloadingSupplier === sup.id;
                        
                        return (
                          <td key={`download-${sup.id}`} className="px-4 py-3 text-center border border-slate-300">
                            <button
                              type="button"
                              disabled={!hasFiles || isDownloading}
                              onClick={() => handleDownloadSupplierFiles(sup.id, sup.name)}
                              className={[
                                "inline-flex h-9 w-9 items-center justify-center rounded-md mx-auto transition",
                                !hasFiles 
                                  ? "bg-slate-100 text-slate-400 cursor-not-allowed" 
                                  : "text-black border-1 border-black bg-gray-200 hover:bg-gray-300",
                                isDownloading ? "opacity-50 cursor-wait" : ""
                              ].join(" ")}
                              title={!hasFiles 
                                ? `No hay archivos para descargar de ${sup.name}` 
                                : `Descargar todos los archivos de ${sup.name}`}
                              aria-label={!hasFiles 
                                ? `No hay archivos para descargar` 
                                : `Descargar archivos del proveedor ${sup.name}`}
                            >
                              {isDownloading ? (
                                <svg className="w-5 h-5 animate-spin" viewBox="0 0 24 24" fill="none">
                                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"></path>
                                </svg>
                              ) : (
                                <svg 
                                  viewBox="0 0 24 24" 
                                  className="w-5 h-5" 
                                  fill="none" 
                                  stroke="currentColor" 
                                  strokeWidth="2"
                                  strokeLinecap="round" 
                                  strokeLinejoin="round" 
                                  aria-hidden="true"
                                >
                                  <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                                  <polyline points="7 10 12 15 17 10" />
                                  <line x1="12" y1="15" x2="12" y2="3" />
                                </svg>
                              )}
                            </button>
                            {!hasFiles && (
                              <div className="mt-1 text-[10px] text-slate-400 select-none">
                                Sin archivos
                              </div>
                            )}
                          </td>
                        );
                      })}
                    </tr>
                  )}

                  {!loading && docs.length === 0 && (
                    <tr>
                      <td className="px-4 py-8 text-center text-gray-500" colSpan={2 + sups.length}>Sin documentos</td>
                    </tr>
                  )}
                </tbody>
              </table>
              </div>)}
              {loading && (
                <div className="p-4 text-sm text-gray-500 bg-white shadow-sm rounded-xl">Cargando…</div>
              )}
            </>
            )}
          </div>
        </div>
      </div>
      
      <ModalSuccess
        showModalSuccess={showModalSuccess}
        closeModalSuccess={() => setShowModalSuccess(false)}
        fill="#43B02A"
        text={modalSuccessText}
      />
      <ModalAlertWarning
        showModalAlertWarning={showAlertModal}
        closeModal={() => setShowAlertModal(false)}
        error={alertMessage}
        color="#CA2D00"
      />
      <ModalDelete
        showModalDelete={showModalDelete}
        closeModal={() => setShowModalDelete(false)}
        accept={handleDeleteSuppliers}
        textType={selectedSuppliersForDelete.size === 1 ? "proveedor" : `${selectedSuppliersForDelete.size} proveedores`}
        pronoun={selectedSuppliersForDelete.size === 1 ? "el" : "los"}
      />
    </div>
  );
}
